export { AppStore } from './app-store'
export { AppStoreProvider, useAppStore, withAppStore } from './app-store-provider'

export interface WbState {
  wb_seller_id: string
  wb_user: string
  projects: Array<{ wb_seller_id: string }>
}
